export default __webpack_public_path__ + "static/media/practitioner_icon.f469e684.svg";